
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GameService } from 'src/app/services/game.service';
import { LocaleService } from 'src/app/services/locale.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import Noty from 'noty';
import { SoundService } from 'src/app/services/audio.service';
import { UtilsService } from 'src/app/services/utils.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-questionModal',
  templateUrl: './questionModal.component.html',
  styleUrls: ['./questionModal.component.scss']
})
export class QuestionModalComponent implements OnInit {
  @ViewChild('camCorderModal', { static: false }) camCorderModal;

  @Input() question: any;
  @Input() isDoubleActive: boolean;
  modalState = 'standby';
  passedTime = 1;
  questionCountdown;
  previewImage;
  endPoiAnswer = ['0','0','0']
  selectedAnswer: any;
  loading = false;
  imageMessage = '';
  imageComment = '';
  dynamic_url;
  achievablePoints = 0;
  locales = {
    gotIt: this.localeService.getTrans('Got it')
  }
  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private sanitizer: DomSanitizer, public gameService: GameService, public localeService: LocaleService, private http: HttpClient, private soundService: SoundService, public utilsService: UtilsService) {
    
  }

  /** Flinkit or partner / custom branding logo for above media in the modal */
  getQuestionModalLogoSrc(): string {
    const g = this.gameService.activeGame;
    if (!g?.partner) {
      return './assets/images/logo_bp.png';
    }
    return this.utilsService.usesBrandedTheme(g.partner, g.tourId)
      ? this.utilsService.brandedCoverSrc(g.partner, g.tourId, './assets/images/pbe.png', 'customLogo')
      : './assets/images/logo_bp.png';
  }

  proceedToQuestion(){
   /*  if(this.modalState === 'endPoi'){
      this.modalState = 'endPoiQuestion';
    } else   */
    
    if(this.modalState === 'standby' || this.modalState === 'timelineEndPoi'){
      // TODO itt lesz a hiba
      this.modalState = 'question';
      if(!this.question.mediaUrl){
        this.startCountdown();
      }
    } else if(this.modalState === 'image'){
        this.modalState = 'imageUpload';

    } else{
      this.modalState = 'infoQuestion';
    }
   
  }

  validateAnswer(){
    if(this.modalState === 'endPoiQuestion'){
        let pins = this.endPoiAnswer[0]+this.endPoiAnswer[1]+this.endPoiAnswer[2];
        console.log(pins.toString())
        if(pins.toString() === this.question.answer.toString()){
          this.activeModal.close({type: 'endPoiSucess' });
        } else{
          this.activeModal.close({type: 'endPoiNotSucess' });
        }
    } else{
      if(this.question.questionType === 'options' || !this.question.questionType){
        if(this.selectedAnswer.isTrue){
          this.correctAnswer(this.selectedAnswer.answer);
          if (this.selectedAnswer.consequencePOI) {
            this.modalState = 'consequencePOI'
          }
        } else{
          this.incorrectAnswer(this.selectedAnswer.answer);
        }
      } else if(this.question.questionType === 'text'){
        const qtAnswer = this.question.answers[0].answer.toString()
        if(this.selectedAnswer){
          if(this.selectedAnswer.toLowerCase().trim() == qtAnswer.toLowerCase().trim()){
            this.correctAnswer(this.selectedAnswer);
          } else{
            this.incorrectAnswer(this.selectedAnswer.answer);
          }
        } else{
          this.incorrectAnswer(this.selectedAnswer.answer);
        }
       
      } else if(this.question.questionType === '2'){
        const upperCap = this.question.answers[0].answer + this.question.answers[0].interval;
        const lowerCap = this.question.answers[0].answer - this.question.answers[0].interval;
        if(this.selectedAnswer > lowerCap && this.selectedAnswer <= upperCap){
          this.correctAnswer(this.selectedAnswer.answer);
        } else{
          this.incorrectAnswer(this.selectedAnswer.answer);
        }
      } else if(this.question.questionType === 'ai'){
        this.loading = true;
        this.http
        .post(environment.baseUrl + 'questions/testAIQuestions', {
          prompt: this.question.answerPrompt,
          answer: this.selectedAnswer
        })
        .subscribe((data: any) => {
          this.loading = false;
          if(data.correct){
            this.correctAnswer(this.selectedAnswer.answer);
          } else{
            this.incorrectAnswer(this.selectedAnswer.answer);
          }
        });
      } else if(this.question.questionType === 'image'){
        this.passedAnswer();
      } else{
        this.incorrectAnswer(this.selectedAnswer.answer);
      }
    }
  }

  uploadImages(event) {
    const files = (event.target as HTMLInputElement).files;
    this.previewImage = files[0];
    

    const reader = new FileReader();
    reader.readAsDataURL(this.previewImage);
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      this.dynamic_url = image.src;
    };
  }

  uploadImage() {
   

    if (!this.previewImage.type.startsWith('image/')) {
      return;
    }
    
    const formData = new FormData();
    formData.append('file', this.previewImage);

    console.log(environment)
    this.loading = true;
    return this.http
      .post(environment.baseUrl + 'file-service/upload', formData)
      .subscribe((data: any) => {
        this.updateUserWithImageAndLocation(data.url);
        this.soundService.play('success');
        this.dropNoty(
          'success',
          this.localeService.getTrans('Image successfully uploaded')
        );
      }, (err)=>{
        this.dropNoty(
          'error',
          this.localeService.getTrans('Image upload failed. Maybe it is a problem with the file size. Please try again with selecting a file from your gallery or take a new photo using your front camera.')
        )
        this.loading = false;
      });
  }

  getPlainText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText.trim();
  }

  updateUserWithImageAndLocation(fileUrl) {
     this.http
      .post(environment.baseUrl + 'games/updateUserWithImageAndLocation', {
        fileUrl,
        text: this.question.title ? this.getPlainText(this.question.title) : this.getPlainText(this.question.question),
        user: this.gameService?.me,
      })
      .subscribe((data: any) => {
        this.imageComment = ''
        this.validateAnswer();
        this.dropNoty(
          'info',
          this.localeService.getTrans('Image successfully uploaded')
        );
        this.loading = false;
        this.modalService.dismissAll();
      });

  }

  dropNoty(type, text, clickEvent?, timeout?) {
    new Noty({
      type: type,
      text: text,
      killer: true,
      timeout,
    }).show();
  }

  dropCamcorder() {
    this.imageMessage = this.getPlainText(this.question.question);
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'environment');
    input.style.display = 'none'; // hide it from user
  
    // Attach to DOM
    document.body.appendChild(input);
  
    console.log('EVENT START');
  
    input.onchange = (event: any) => {
      console.log('EVENT');
      const files = (event.target as HTMLInputElement).files;
      if (files && files.length > 0) {
        this.previewImage = files[0];
  
        const reader = new FileReader();
        reader.readAsDataURL(this.previewImage);
  
        reader.onload = () => {
          this.dynamic_url = reader.result as string;
          this.modalService.open(this.camCorderModal, {
            centered: true,
            backdrop: 'static'
          });
        };
      }
  
      // Clean up input element after use
      document.body.removeChild(input);
    };
  
    // Clear value and open dialog
    input.value = '';
    input.click();
  }
  

  navigateToUrl(url: string) {
    window.location.href = url
  }

  getFormattedQuestion(string: string) {
    // Extract <a> tag href value
    const linkMatch = string.match(/<a[^>]*href="([^"]*)"/);
    const extractedUrl = linkMatch ? linkMatch[1] : null;
  
    if (extractedUrl) {
      // If there's an href in the anchor tag, replace the <a> with its inner text
      const linkText = string.replace(/<a[^>]*>(.*?)<\/a>/, '$1');
      // Pass the URL to the navigateToUrl method when clicking the button
      return {
        html: linkText, // Only text content to show inside the button
        url: extractedUrl
      };
    }
  
    // Return the formatted string if no link is found
    return { html: string, url: null };
  }
  

  closeModalWithInfo(){
    this.activeModal.close({type: 'closeWithInfo'});
  }

  closeModal(){
    this.activeModal.close({type: 'backpack', data: this.question });
  }

  closeModalWithoutEvent(){
    this.activeModal.close({type: 'closeWithoutEvent'});
  }

  skipQuestion(){
    Swal.fire({
      icon: 'warning',
      title: this.localeService.getTrans('Skip this question?'),
      text: this.localeService.getTrans('If you skip this question, you won\'t be able to pick it up again. Do you really want to skip it?'),
      showCancelButton: true,
      confirmButtonText: this.localeService.getTrans('Yes, skip it'),
      cancelButtonText: this.localeService.getTrans('Cancel') || this.localeService.getTrans('Back'),
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed skip - close modal with skipped type
        this.activeModal.close({type: 'skipped', data: this.question, answer: '', time: this.passedTime});
      }
    });
  }

  correctAnswer(answer?){
    this.activeModal.close({type: 'correct', data: this.question, answer, time: this.passedTime });

  }
  passedAnswer(answer?){
    this.activeModal.close({type: 'passed', data: this.question, answer, time: this.passedTime });

  }
  incorrectAnswer(answer){
    this.activeModal.close({type: 'incorrect', data: this.question, answer, time: this.passedTime});
  }
  toggleAnswer(answer: any){
    this.selectedAnswer = answer;
  }
  isSpeedScoringActive(): boolean {
    return !!this.gameService.activeGame?.tourId?.isSpeedScoring && !!this.question?.time;
  }

  calculateAchievablePoints() {
    const basePoints = this.question.points || 0;
    const totalTime = this.question.time;
    const usedTime = this.passedTime;
    
    if (!this.gameService.activeGame?.tourId?.isSpeedScoring) {
      this.achievablePoints = basePoints;
      return;
    }
    
    // In speed scoring mode: Linear decrease within time limit
    const ratio = (totalTime - usedTime + 1) / totalTime;
    let earnedPoints = Math.max(1, Math.round(basePoints * ratio));
    
    // Apply double points if active
    if (this.isDoubleActive) {
      earnedPoints *= 2;
    }
    
    this.achievablePoints = earnedPoints;
  }

  startCountdown(){
     // Initialize achievable points
     this.calculateAchievablePoints();
     
     this.questionCountdown = setInterval(()=>{
       if(this.passedTime < this.question.time){
         this.passedTime += 1;
         this.calculateAchievablePoints();
       } else{
         // Time is up - close modal (same behavior for both modes)
         this.activeModal.close({type: 'outOfTime', data: this.question, answer: '', time: this.passedTime});
         clearInterval(this.questionCountdown); 
       }
     }, 1000);
  }
  imageLoaded(){
    if(this.question.isQuestion) {
       this.startCountdown();
    }
  }
  ngOnInit() {
    if(this.question.isQuestion){
      if(this.question.isEndPOITimeline){
        this.modalState = 'timelineEndPoi';
      } else{

        console.log(this.question)

        if(this.question.questionType === 'image'){
          this.modalState = 'imageUpload';
          console.log('Modal state set to imageUpload for image question');
        }


        if(this.question.questionType === 'story'){
          this.modalState = 'story';
        } else if(this.question.questionType === 'endPoi'){
          this.modalState = 'endPoi';
        }
      }
     
    } else{
      this.modalState = 'info';
    }
   
  }

}
